import React from 'react';
import classnames from 'classnames';
import { useTranslation, Trans } from 'react-i18next';
import { getPremiumFolderProperties } from '../../../../../_helpers';
import Button, { ProfileOwnerWatchButton } from '../../../../../../Button';
import PointsIcon from '../../../../../../Icons/Points';
import { IconSize } from '../../../../../../Icons/IconWrap';
import { BiEventType } from '../../../../../../biLogger/constants';
import s from './PremiumOverlay.scss';
var PremiumOverlay = function (_a) {
    var deviation = _a.deviation, className = _a.className, isSmall = _a.isSmall;
    var t = useTranslation().t;
    var _b = getPremiumFolderProperties(deviation, true), dollarPrice = _b.dollarPrice, pointPrice = _b.pointPrice, isPaidFolder = _b.isPaidFolder;
    return (React.createElement("div", { className: classnames(s['root'], isSmall && s['small'], className) },
        React.createElement("div", { className: s['label'] }, isPaidFolder
            ? t('deviationview.overlay.premiumFolder.unlockHint.pay')
            : t('deviationview.overlay.premiumFolder.unlockHint.watch')),
        isPaidFolder ? (React.createElement(Button, { height: "medium", className: classnames(s['button'], s['buy-button']), view: "b1", biData: {
                evid: BiEventType.DEFAULT,
                click_info: 'thumb.premiumFolder.unlock',
            } },
            React.createElement(Trans, { i18nKey: "deviationview.overlay.premiumFolder.button.pay" },
                "Unlock for $",
                { dollarPrice: dollarPrice },
                " /",
                React.createElement(PointsIcon, { className: s['points-icon'], size: IconSize.SMALL, disableDefaultColors: true }),
                " ",
                { pointPrice: pointPrice }))) : (deviation.author && (React.createElement(ProfileOwnerWatchButton, { className: s['button'], user: deviation.author })))));
};
PremiumOverlay.displayName = 'PremiumOverlay';
export default PremiumOverlay;
//# sourceMappingURL=PremiumOverlay.js.map